export function isCompanyCodeConfigured(
  companyCode: string,
  configuredCompanyCodes: string
): boolean {
  if (!companyCode || !configuredCompanyCodes) return false;

  const normalizedCompanyCode = companyCode.trim();

  return configuredCompanyCodes
    .split(',')
    .map((configuredCode) => configuredCode.trim())
    .filter(Boolean)
    .includes(normalizedCompanyCode);
}